<template>
    <div :id="hash" class="ab-box" :class="{'right' : index % 2 === 0}">
        <div class="ab-box__img" data-aos="fade-in" data-aos-duration="3000" data-aos-delay="400">
            <Image :image="data.image" :isLazy="false" :width="660"></Image>
        </div>

        <div class="ab-box__text" :data-aos="getAnimationName(index)" data-aos-duration="1800" data-aos-delay="600">
            <h4 class="ab-box__title">{{ data.title }}</h4>
            <p class="ab-box__lead" v-html="data.lead"></p>
        </div>
    </div>
</template>

<script>
import Image from "../elements/Image.vue";

export default {
  data () {
    return {
    }
  },
  watch: {
  },
    name: "AbBox",
    components: {
        Image,
    },
    props: {
        index: {
            type: Number
        },
        data: {
            type: Object
        }
    },
    computed: {
        hash() {
            if(this.data.url) {
                return this.data.url.substring(1);
            }
            return null;
        }
    },
    methods: {
        getAnimationName(index) {
            if(index % 2 === 0) {
                return 'fade-right';
            }
            return 'fade-left';
        }
    }
};
</script>
